import { render, staticRenderFns } from "./PaydayLoans.vue?vue&type=template&id=a68330e8&"
import script from "./PaydayLoans.vue?vue&type=script&lang=js&"
export * from "./PaydayLoans.vue?vue&type=script&lang=js&"
import style0 from "./PaydayLoans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports